exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-title{cursor:pointer\n}\n.v-toolbar{background-color:transparent!important;box-shadow:none!important\n}\n.navbar-actions .v-icon{cursor:pointer;font-size:28px!important;margin-left:8px;margin-right:8px\n}\n.v-speed-dial{margin-left:auto;width:80px\n}\n.v-speed-dial .main-btn .v-icon{left:-8px!important\n}\n.main-search-input{min-width:400px\n}\n.main-search-input .v-text-field .v-label{max-width:95%\n}\n.main-search-input .search-input{margin-bottom:12px\n}", ""]);

// exports
